import { useEffect } from 'react';

export const useScrollToTopOnChange = (deps: string | null) => {
  useEffect(() => {
    if (!deps) {
      return;
    }

    window.scrollTo({
      top: 0,
    });
  }, [deps]);
};
